import 'select2';

const initShopProducts = (section) => {
  if (section.dataset.shopProductsReady === 'true') return;

  const form = section.querySelector('[data-product-filters]');
  const grid = section.querySelector('[data-product-grid]');
  const status = section.querySelector('[data-product-status]');
  const empty = section.querySelector('[data-product-empty]');
  const loadMore = section.querySelector('[data-product-load-more]');
  const loadMoreWrap = section.querySelector('[data-product-load-more-wrap]');
  const clearFilters = section.querySelector('[data-product-clear]');
  const modes = Array.from(section.querySelectorAll('[data-product-mode]'));
  const selects = Array.from(form?.querySelectorAll('select') || []);
  if (!form || !grid || !loadMore) return;

  const initSelects = () => {
    selects.forEach((select) => {
      if ($(select).hasClass('select2-hidden-accessible')) return;

      const isCategory = select.name === 'category';
      const dropdownParent = $(select).closest('label');

      $(select).select2({
        allowClear: select.name !== 'sort',
        dropdownAutoWidth: false,
        dropdownCssClass: 'shop-products__select-dropdown',
        dropdownParent,
        minimumResultsForSearch: isCategory ? 7 : Infinity,
        placeholder: select.options[0]?.textContent || '',
        width: 'auto',
      });
    });
  };

  const refreshSelects = () => {
    selects.forEach((select) => $(select).trigger('change.select2'));
  };

  let mode = 'bestsellers';
  let offset = Number.parseInt(section.dataset.offset, 10) || 0;
  let controller = null;
  let requestSequence = 0;
  const state = {
    // The shop archive renders `data-category="0"`; treat it as no filter,
    // otherwise the string "0" counts as a selected category.
    category:
      section.dataset.category && section.dataset.category !== '0'
        ? section.dataset.category
        : '',
    size: '',
    sort: 'default',
  };

  const cleanUrl = new URL(window.location.href);
  let urlChanged = false;
  ['category', 'size', 'sort', 'mode'].forEach((parameter) => {
    if (cleanUrl.searchParams.has(parameter)) {
      cleanUrl.searchParams.delete(parameter);
      urlChanged = true;
    }
  });
  if (urlChanged) window.history.replaceState({}, '', cleanUrl);

  const setMode = (nextMode) => {
    mode = nextMode;
    modes.forEach((button) => {
      const active = button.dataset.productMode === mode;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  };

  const syncClearButton = () => {
    if (!clearFilters) return;

    clearFilters.hidden = !(
      (form.elements.category && state.category) ||
      state.size
    );
  };

  const values = () => ({ ...state });

  const setLoadMoreLoading = (isLoading) => {
    if (isLoading) {
      loadMore.style.width = `${Math.ceil(
        loadMore.getBoundingClientRect().width
      )}px`;
      loadMore.disabled = true;
      loadMore.setAttribute('aria-busy', 'true');
      return;
    }

    loadMore.disabled = false;
    loadMore.removeAttribute('aria-busy');
    loadMore.style.removeProperty('width');
  };

  const request = async (append = false) => {
    controller?.abort();
    controller = new AbortController();
    const requestController = controller;
    const requestId = ++requestSequence;
    const currentState = values();
    const params = new URLSearchParams();

    if (currentState.category) params.set('category', currentState.category);
    if (currentState.size) params.set('size', currentState.size);
    if (currentState.sort !== 'default') params.set('sort', currentState.sort);
    params.set('mode', mode);
    params.set('offset', append ? offset : 0);
    if (section.dataset.archive === 'shop') params.set('archive', 'shop');
    if (section.dataset.language) {
      params.set('language', section.dataset.language);
    }
    params.set('_request', Date.now());

    section.classList.add('is-loading');
    setLoadMoreLoading(true);
    status.textContent = append
      ? section.dataset.loadingMore
      : section.dataset.loading;

    try {
      const response = await fetch(`${section.dataset.endpoint}?${params}`, {
        cache: 'no-store',
        signal: requestController.signal,
      });
      if (!response.ok) throw new Error('Request failed');
      const result = await response.json();

      if (requestId !== requestSequence) return;

      if (append) {
        grid.insertAdjacentHTML('beforeend', result.html);
        offset = result.nextOffset;
      } else {
        grid.innerHTML = result.html;
        offset = result.nextOffset;
      }
      document.dispatchEvent(new Event('holytaste:wishlist-sync'));

      empty.hidden = result.total > 0;
      loadMore.hidden = !result.hasMore;
      if (loadMoreWrap) loadMoreWrap.hidden = !result.hasMore;
      status.textContent = result.total
        ? section.dataset.loaded
        : section.dataset.noResults;
      document.body.dispatchEvent(new Event('wc_fragment_refresh'));
    } catch (error) {
      if (error.name !== 'AbortError') {
        status.textContent = section.dataset.error;
      }
    } finally {
      if (requestId === requestSequence) {
        section.classList.remove('is-loading');
        setLoadMoreLoading(false);
      }
    }
  };

  $(form).on('change', 'select', (event) => {
    state[event.target.name] = event.target.value;
    syncClearButton();
    request(false);
  });
  loadMore.addEventListener('click', () => request(true));
  modes.forEach((button) => {
    button.addEventListener('click', () => {
      setMode(button.dataset.productMode);

      // Bestsellers and New Arrivals are orderings themselves, so a custom
      // sort would override them; reset it so the chosen mode takes effect.
      if (form.elements.sort && state.sort !== 'default') {
        state.sort = 'default';
        $(form.elements.sort).val('default').trigger('change.select2');
      }

      syncClearButton();
      request(false);
    });
  });

  clearFilters?.addEventListener('click', () => {
    ['category', 'size'].forEach((name) => {
      if (form.elements[name]) {
        state[name] = '';
        $(form.elements[name]).val('');
      }
    });
    refreshSelects();
    syncClearButton();
    request(false);
  });

  initSelects();
  syncClearButton();

  section.dataset.shopProductsReady = 'true';
};

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-shop-products]').forEach(initShopProducts);
});
